<header #stickyHeaderRef [ngClass]="headerMode + (isHeaderFixed || !isAtTop ? ' fixed-mode' : '') + (isServer ? ' isServer' : '')">
    <div [ngClass]="headerMode === HeaderMode.Inner ? 'w100' : 'padding-main-container'">
        <!-- In order for avoiding CLS the banner top must always hug space even when it is not exist -->
        @if (headerMode !== HeaderMode.Scroll || (bannerTop && bannerTop.txt)) {
            @if (bannerTop && bannerTop.txt) {
                <a
                    [href]="bannerTop.link"
                    class="full-width-in-limited-parent flex a-center j-center banner-msg"
                    [ngStyle]="{
                        'background-color': headerMode !== HeaderMode.Transparent ? bannerTop.bgClr : '',
                        color: headerMode !== HeaderMode.Transparent ? bannerTop.clr : 'unset',
                    }"
                >
                    <span>{{ bannerTop.txt }}</span>
                </a>
            } @else {
                <!-- placeholder to prevent CLS (cumulative layout shifting) -->
                <div
                    class="full-width-in-limited-parent flex a-center j-center banner-msg"
                    [ngStyle]="{
                        'background-color': headerMode !== HeaderMode.Transparent && bannerTop ? bannerTop.bgClr : '',
                        color: headerMode !== HeaderMode.Transparent && bannerTop ? bannerTop.clr : 'unset',
                    }"
                    [ngClass]="{ darkBlueBackground: headerMode !== HeaderMode.Transparent && !bannerTop }"
                    aria-hidden="true"
                ></div>
            }
        }
        <section class="full-width-in-limited-parent">
            <div
                class="header-main-row"
                [ngClass]="{
                    'padding-main-container': headerMode !== HeaderMode.Inner,
                    w100: headerMode === HeaderMode.Inner,
                }"
            >
                <div class="flex2">
                    <div class="linksContainer upperBar firstRow">
                        <smart-router-link link="/" [isRouterLink]="isAngularPage">
                            <span class="logo-yeshiva">
                                <yeshiva-logo [customLogo]="true"></yeshiva-logo>
                                <yeshiva-caption-logo></yeshiva-caption-logo>
                            </span>
                        </smart-router-link>
                        <div class="main-link-container">
                            <smart-router-link class="header-site-link sub-list-container relative" link="/midrash" [isRouterLink]="isAngularPage">
                                <span
                                    i18n="@@beitHaMidrash"
                                    class="header-site-link middleContainer"
                                    [ngClass]="{
                                        active: activeLocation() === SiteLocations.Midrash,
                                    }"
                                    >בית מדרש
                                </span>
                                @if (!isServer) {
                                    <header-sub-links [links]="groupsLinks.get('midrash-links')" [isAngularApp]="isAngularApp"></header-sub-links>
                                }
                            </smart-router-link>
                            <smart-router-link class="header-site-link sub-list-container relative" link="/ask" [isRouterLink]="isAngularPage">
                                <span
                                    i18n="@@askTheRav"
                                    class="header-site-link middleContainer"
                                    [ngClass]="{
                                        active: activeLocation() === SiteLocations.Ask,
                                    }"
                                    >שאל את הרב
                                </span>
                                @if (!isServer) {
                                    <header-sub-links [links]="groupsLinks.get('ask-links')" [isAngularApp]="isAngularApp"></header-sub-links>
                                }
                            </smart-router-link>
                            <a class="sub-list-container relative" href="/calendar"
                                ><span
                                    i18n="@@calendar"
                                    class="header-site-link middleContainer"
                                    [ngClass]="{
                                        active: activeLocation() === SiteLocations.Calendar,
                                    }"
                                >
                                    לוח שנה
                                </span>
                                @if (!isServer) {
                                    <header-sub-links [links]="groupsLinks.get('calendar-links')" [isAngularApp]="isAngularApp"></header-sub-links>
                                }
                            </a>
                            <a class="sub-list-container relative" href="/wiki"
                                ><span
                                    i18n="@@wiki"
                                    class="header-site-link middleContainer"
                                    [ngClass]="{
                                        active: activeLocation() === SiteLocations.Wiki,
                                    }"
                                >
                                    ויקישיבה
                                </span>
                                @if (!isServer) {
                                    <header-sub-links [links]="groupsLinks.get('viki-links')" [isAngularApp]="isAngularApp"></header-sub-links>
                                }
                            </a>
                            <a
                                i18n="@@dedications"
                                class="header-site-link middleContainer"
                                [ngClass]="{
                                    active: activeLocation() === SiteLocations.Dedication,
                                }"
                                href="/dedication"
                            >
                                תרומות
                            </a>
                            <!-- nihul home: shown while connected as any nihul user; rabbi-only accounts land on their own area -->
                            @if (showNihulHome()) {
                                <smart-router-link class="header-site-link middleContainer" [link]="nihulHomeLink()" [isRouterLink]="isAngularPage" title="ניהול תוכן">
                                    <span class="header-site-link middleContainer">ניהול</span>
                                </smart-router-link>
                            }
                        </div>

                        <div id="bar-tools" class="flex-container upperBar col a-end">
                            <a
                                title="inn.co.il"
                                class="inn-logo-link"
                                [ngClass]="{
                                    light: headerMode === HeaderMode.Transparent,
                                }"
                                href="https://www.inn.co.il"
                            >
                                <ng-container *ngTemplateOutlet="innLogo"></ng-container>
                            </a>
                            <a
                                [class.transparent-mode]="headerMode === HeaderMode.Transparent"
                                class="deepBlue middleIconContainer header-site-link"
                                [href]="otherLangLink()"
                                aria-label="Change Language"
                            >
                                <span class="mat-icon" aria-hidden="true">language</span>
                            </a>
                            <button type="button" class="deepBlue whiteInMain middleIconContainer search-ic" aria-label="Search" (click)="onSearchClick.emit()">
                                <span class="mat-icon whiteInMain clickableIcon" aria-hidden="true">search</span>
                            </button>
                            <button type="button" class="deepBlue whiteInMain middleIconContainer" aria-label="Share" (click)="toggleSocialShareBox.emit(true)">
                                <span class="mat-icon whiteInMain clickableIcon" aria-hidden="true">share</span>
                            </button>
                            <!-- nihul staff shortcuts: login only when logged out and this browser
                                 remembers a nihul logon; logout while connected as a nihul user -->
                            @if (showNihulLogin()) {
                                <button
                                    type="button"
                                    class="deepBlue whiteInMain middleIconContainer"
                                    title="כניסה לניהול תוכן"
                                    aria-label="Nihul login"
                                    (click)="openNihulLogin()"
                                >
                                    <span class="mat-icon whiteInMain clickableIcon" aria-hidden="true">admin_panel_settings</span>
                                </button>
                            }
                            @if (showNihulLogout()) {
                                <button
                                    type="button"
                                    class="deepBlue whiteInMain middleIconContainer"
                                    title="התנתקות מהניהול ומהאתר"
                                    aria-label="Nihul logout"
                                    (click)="openNihulLogout()"
                                >
                                    <span class="mat-icon whiteInMain clickableIcon" aria-hidden="true">logout</span>
                                </button>
                            }
                            <div class="deepBlue whiteInMain middleIconContainer" [attr.title]="selfAreaI18N">
                                <smart-router-link
                                    link="/users"
                                    [isRouterLink]="isAngularPage"
                                    class="fw-400 flex header-site-link user-area-link"
                                    ariaLabel="User Area"
                                >
                                    <span class="mat-icon whiteInMain personIcon" aria-hidden="true">person</span>
                                    @if (userNotifications > 0) {
                                        <span class="notification-badge" [class.medium]="badgeSize === 'medium'">{{ userNotifications }}</span>
                                    }
                                </smart-router-link>
                            </div>
                            <button type="button" class="deepBlue whiteInMain middleIconContainer" aria-label="Open menu" (click)="toggleMenu.emit()">
                                <span class="mat-icon whiteInMain clickableIcon" aria-hidden="true">menu</span>
                            </button>
                        </div>
                    </div>
                    @if (headerMode === HeaderMode.Inner) {
                        <div class="dedicationDateContainer darkBlueTe whiteBackground page-width-padding-end">
                            <section class="w100 padding-inline-10 flex bet a-center">
                                <ng-container *ngTemplateOutlet="secondRow"></ng-container>
                            </section>
                        </div>
                    }
                </div>
            </div>
        </section>
        @if (headerMode === HeaderMode.Transparent) {
            <section class="dedication-date-container">
                <ng-container *ngTemplateOutlet="secondRow"></ng-container>
            </section>
        }
    </div>
</header>

<ng-template #secondRow>
    <section class="second-row w100 flex around a-center">
        <!-- hyper link tag inside empty div due to universal bug in which it doesn't group up a tag with content -->
        <div>
            <div>
                @if (isHeb) {
                    <a
                        [ngClass]="{ serverHide: isServer && headerMode === HeaderMode.Transparent }"
                        (click)="$event.stopPropagation()"
                        class="row2Button"
                        href="/reg/dailyEmunaReg.aspx"
                        >לימוד יומי</a
                    >
                }
                <a class="margin-inline-start-6" title="Calendar" href="/calendar">{{ hebrewDate }}</a>
                @if (omer) {
                    <span>, {{ omer }} </span>
                }
                <span class="curr-daily-time-slot">
                    @if (!isServer && dailyTimeHeader) {
                        <span class="curr-daily-time relative opacity-8 opacity-hover-10"
                            >,
                            <ng-container *ngTemplateOutlet="dailyTime; context: { time: dailyTimeHeader.closestTimeDay }"></ng-container>
                            <ul class="daily-time-list">
                                <li class="t-center padding-10 xlarge">{{ dayTimes }}{{ dailyTimeHeader.currPlace.name }}</li>
                                @for (time of dailyTimeHeader.mainDailyTimes; track time.name) {
                                    <li class="flex a-center bet" [ngClass]="time.modeTime">
                                        <ng-container *ngTemplateOutlet="dailyTime; context: { time: time }"></ng-container>
                                    </li>
                                }
                                <li class="flex col a-center bet">
                                    <a href="/calendar/timesday/" (click)="$event.stopPropagation()">{{ moreTimes }}</a>
                                </li>
                            </ul>
                        </span>
                    } @else {
                        <span class="curr-daily-time-placeholder" aria-hidden="true">, חצות היום 00:00</span>
                    }
                </span>
            </div>
        </div>
        <section class="daily-donor">
            <p>{{ dailyDonor }}</p>
            <a [ngClass]="{ serverHide: isServer && headerMode === HeaderMode.Transparent }" class="row2Button" href="/dedication" i18n="@@dedicate">הקדש</a>
        </section>
    </section>
</ng-template>

<!-- Todo: get it from mat-icon -->
<ng-template #innLogo>
    <svg viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="var(--inn-logo-color)" stroke="none">
            <path
                d="M567 5030 c-233 -40 -419 -210 -472 -432 -22 -96 -22 -3971 0 -4067
19 -78 71 -180 125 -243 56 -65 171 -139 261 -169 l74 -24 1995 0 1995 0 74
24 c90 30 205 104 261 169 54 63 106 165 125 243 22 96 22 3971 0 4067 -53
224 -239 393 -476 431 -77 13 -3888 13 -3962 1z m2953 -891 c163 -26 255 -115
275 -265 8 -61 -7 -152 -35 -208 -11 -23 -56 -84 -100 -136 -226 -267 -420
-622 -589 -1079 -213 -573 -331 -1099 -357 -1588 l-7 -133 -493 0 c-423 0
-495 2 -507 15 -59 59 -6 590 99 995 174 669 483 1324 809 1715 l75 90 -698 5
-697 5 -8 90 c-9 95 -3 478 8 495 9 14 2137 14 2225 -1z"
            />
        </g>
    </svg>
</ng-template>

<ng-template #dailyTime let-time="time">
    <span> {{ time.name }} </span>
    <span>{{ time.value }}</span>
</ng-template>
